import React, { createContext, useId } from "react";
import { FirebaseConfig } from "config";
import app from "firebase/compat/app";
import "firebase/compat/database";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";
import { store } from "./store/store";

import { PPTokenGenerator } from "./actions/tokenactions";

//Areas Actions
import {
  addArea,
  updateArea,
  updateAreaBroker,
  fetchAllUnAssignedAreas,
  fetchAllAssignedAreas,
  fetchAllAreas,
  removeBrokerFromArea,
  deleteArea
} from "./actions/areaactions";

//region actions
import {
  addRegion,
  fetchAllRegions,
  updateRegion,
  updateRegionAreas,
  removeAreaFromRegion,
  fetchBrokerRegions
} from "./actions/regionactions";

import {
  GenerateListingDescription,
  clearAiReducer,
  GenerateListingKeywords
} from "./actions/aiactions";

import {
  fetchUser,
  emailSignUp,
  mobileSignIn,
  clearLoginError,
  signIn,
  facebookSignIn,
  appleSignIn,
  signOut,
  updateProfile,
  sendResetMail,
  updatePushToken,
  updateProfileImage,
  addBrokerHomeOffice,
  updateWebProfileImage,
  requestPhoneOtpDevice,
  deleteUser,
  validateReferer,
  checkUserExists,
  monitorProfileChanges,
  CheckUserSignedIn,
  fetchLoggedInUser,
  adminEmailSignUp,


} from "./actions/authactions";
import {
  fetchAgent,
  addAgentP24,
  addPpAgent,
  addWebsite,
  UpdateAgentP24
} from "./actions/agentsactions";
import {
  publishToWeb,
  publishto24prop,
  publishToprivateprop,
  getPrivatePropStatus,
  clearPublishErrors,
  syncTop24,
  syncToPP,
  syncToWebsite,
  updatePrivatePropStatus
} from "./actions/publishaction";
import {
  fetchContacts,
  addContact,
  fetchJmUser,
  addJmUser
} from "./actions/contactaction";
import { updateUserConsentform } from "./actions/consentformuploadaction";

import { AddPaymentMethod } from "./actions/paymentactions";

import { CreateChat, FetchChats } from "./actions/chatactions";

import {
  fetchBookings,
  updateBooking,
  cancelBooking
} from "./actions/bookinglistactions";
import {
  fetchOffers,
  addOffers,
  updateOffers
} from "./actions/bookingoffersactions";
import {
  fetchCancelReasons,
  editCancellationReason
} from "./actions/cancelreasonactions";
import { fetchUserTypes, editUserType } from "./actions/usertypesaction";

import {
  fetchCommercialTypes,
  editCommercialType
} from "./actions/commercialtypesaction";
import {
  fetchIndustrialTypes,
  editIndustrialType
} from "./actions/industrialtypesaction";
// import { CreateMeetingLink, DeleteMeetingLink } from "./actions/meetingaction";

import { getEstimate, clearEstimate } from "./actions/estimateactions";
import { fetchBrokerEarnings } from "./actions/brokerearningaction";
import { fetchEarningsReport } from "./actions/earningreportsaction";
import {
  fetchNotifications,
  editNotifications,
  sendNotification,
  fetchUserNotification,
  deleteNotification,
  UpdateNotification
} from "./actions/notificationactions";
import { fetchPromos, editPromo } from "./actions/promoactions";
import {
  addUser,
  fetchUsers,
  fetchBrokers,
  editUser,
  SaveUsersDeviceInfo,
  fetchAdmins,
  fetchBroker,
  editUserSharedBrokers,
  AddBroker,
  AddP24,
  AddWebsite,
  EditBroker,
  editBrokerApproval
} from "./actions/usersactions";
import {
  fetchSettings,
  editSettings,
  clearSettingsViewError
} from "./actions/settingsactions";
import {
  createMeetingRoom,
  deleteMeetingRoom
} from "./actions/meetingroomactions";
import { createOpenfireUser } from "./actions/openfireuseractions";
import {
  fetchPaymentMethods,
  addToWallet,
  updateWalletBalance,
  clearMessage
} from "./actions/paymentactions";
import {
  updateEventPickup,
  updateEventDrop,
  updateEventPractice,
  updatSelPointType,
  clearEventPoints
} from "./actions/eventactions";
import { fetchTasks, acceptTask, cancelTask } from "./actions/taskactions";
import {
  fetchBookingLocations,
  stopLocationFetch
} from "./actions/locationactions";
import {
  leaveChat,
  fetchChatMessages,
  SendChatMesssage
} from "./actions/chatactions";

import {
  SendBulkPushNotification,
  SendPushNotification,
  SendEnquiryGroupChatNotification
} from "./actions/pushnotificationsactions";

import {
  fetchBrokerNotes,
  addBrokersNotes,
  stopFetchBrokerNotes
} from "./actions/brokernotesactions";
import { fetchWithdraws, completeWithdraw } from "./actions/withdrawactions";

import { MinutesPassed, GetDateString } from "./other/DateFunctions";
import {
  fetchCoordsfromPlace,
  fetchAddressfromCoords,
  getDriveTime,
  getRouteDetails
} from "./other/GoogleAPIFunctions";
import { GetDistance, GetEventDistance } from "./other/GeoFunctions";

//Enquiry Actions

import {
  UnarchiveEnquiry,
  CreateEnquiry,
  ArchiveEnquiry,
  ViewedEnquiry,
  UnreadEnquiry,
  DeleteEnquiry,
  UpdateEnquiry,
  RemovePullforwardForAll,
  clearEnquiryErrors,
  clearPullforwardEnquirySuccess,
  fetchUserEnquiryhistory,
  addtoEnquiryTimeline,
  fetchformEnquiryTimeline,
  fetchEnquriesFromOtherLocations,
  fetchSingleEnquiry,
  AddEnquiryToCallList,
  AddEnquiryToWhiteboard,
  AddEnquiryToInvestor,
  fetchBranchesEnquiries,
  fetchCurrentAdminsBranchEnquiries,
  RemoveEnquiryFromCallList,
  RemoveEnquiryFromWhiteboard,
  RemoveEnquiryFromInvestor,
  PullforwardEnquiryForMe,
  PullforwardEnquiryForAll,
  RemovePullforwardEnquiryForMe
} from "./actions/enquiryactions";

//Branch Actions

import {
  clearBranchErrors,
  createBranch,
  fetchAllBranches,
  get_Branch_By_Name,
  updateBranch,
  deleteBranch
} from "./actions/branchactions";
//PushNotification action
import { registerForPushNotificationsAsync } from "./actions/pushnotificationsactions";

//Listing actions

import {
  CreateListing,
  DeleteListing,
  UpdateListing,
  UpdateListingPrimary,
  clearListingErrors,
  clearListingErrorsPrimary,
  clearUserErrors,
  fetchListingInArea,
  fetchUserListinghistory,
  fetchAllListings,
  fetchAllBranchListings,
  fetchCurrentAdminsBranchListings,
  DeleteListingPdf,
  generatePDF,
  RemovePullforwardListingsForAll,
  uploadListingWithBrochure,
  duplicateListing,
  getFileUrl,
  generatePdfLinks,

} from "./actions/Listingactions";

//Matching Actions
import {
  MatchListingToEnquiry,
  MatchEnquiryToListings
} from "./actions/matchingactions";
// Canvassing Action
import {
  CreateCanvas,
  fetchCanvas,
  UpdateCanvas,
  DeleteCanvas
} from "./actions/canvasactions";
import {
  fetchCities,
  fetchSuburbs,
  fetchWebsiteAreas,
  fetchPPCities,
  fetchPPSuburbs
} from "./actions/cityactions";

import { fetchPublication } from "./actions/publishaction";

/* landlord Actions */
import {
  createLandlord,
  fetchLandlords,
  updateLandlord
} from "./actions/landlordactions";
import { fetchPPLeads, fetchP24Leads, fetchPPRef, fetchPPListingsActivity } from "./actions/leadsaction";
const FirebaseContext = createContext(null);

const FirebaseProvider = ({ children }) => {
  let firebase = {
    app: null,
    database: null,
    auth: null,
    storage: null
  };

  if (!app.apps.length) {
    app.initializeApp(FirebaseConfig);
    console.log("hallo checking for app being initialized", app);
    firebase = {
      app: app,
      database: app.database(),
      auth: app.auth(),
      storage: app.storage(),
      authRef: app.auth(),
      facebookProvider: new app.auth.FacebookAuthProvider(),
      googleProvider: new app.auth.GoogleAuthProvider(),
      appleProvider: new app.auth.OAuthProvider("apple.com"),
      phoneProvider: new app.auth.PhoneAuthProvider(),
      RecaptchaVerifier: app.auth.RecaptchaVerifier,
      captchaGenerator: (element) => new app.auth.RecaptchaVerifier(element),
      facebookCredential: (token) =>
        app.auth.FacebookAuthProvider.credential(token),
      googleCredential: (idToken) =>
        app.auth.GoogleAuthProvider.credential(idToken),
      mobileAuthCredential: (verificationId, code) =>
        app.auth.PhoneAuthProvider.credential(verificationId, code),
      usersRef: app.database().ref("users"),

      //regions ref
      RegionsRef: app.database().ref(`Region`),

      //Areas Ref
      areasRef: () => app.database().ref(`Area`),

      unAssignedAreasRef: app.database().ref(`unAssignedAreas`),
      singleUnassignedAreasRef: (area) =>
        app
          .database()
          .ref(`unAssignedAreas`)
          .orderByChild("Area")
          .equalTo(area),

      AssignedAreasRef: app.database().ref(`Area`),

      AreasRef: app.database().ref(`Area`),

      singleAssignedAreasRef: (area) =>
        app.database().ref(`Area`).orderByChild("Location").equalTo(area),

      //pullforward ref
      pullforwardEnquiryRef: (enquiryId) =>
        app.database().ref(`Enquiries/${enquiryId}/pullforward`),

      removePullforwardEnquiryForMeRef: (enquiryId) =>
        app
          .database()
          .ref(`Enquiries/${enquiryId}/pullforward/pullforwardBrokers`),

      //Main Enquiries Ref
      EnquiryRef: app.database().ref("Enquiries"),

      EnquiryOfficeRef: (office) =>
        app.database().ref("Enquiries").orderByChild("office").equalTo(office),

      EnquiryLocationRef: () => app.database().ref(`Enquiries`), //adjusted

      EnquiryTimeLineRef: (enquiryID) =>
        app.database().ref(`timeline/${enquiryID}`),

      EnquiryLocationRef: () => app.database().ref(`Enquiries`), //adjusted

      //SingleEnquiry
      singleEnquiryRef: (
        EnquiryId //adjusted
      ) => app.database().ref(`Enquiries/${EnquiryId}`),

      //API logo ref
      apiLogoRef: () =>
        app.storage().ref(`assets/API_Square_Logo_320px.png`),

      //ArchiveEnquiry
      archiveEnquiryRef: (enquiryId) =>
        app.database().ref(`Enquiries/${enquiryId}/archivedbroker`), //adjusted

      //Enquiry Call List Ref
      callListEnquiryRef: (EnquiryId) =>
        app.database().ref(`Enquiries/${EnquiryId}/BrokerCallList`), //adjusted

      //Enquiry Whiteboard Ref
      whiteboardEnquiryRef: (EnquiryId) =>
        app.database().ref(`Enquiries/${EnquiryId}/BrokerWhiteboard`), //adjusted

      //Enquiry Investors Ref
      investorsEnquiryRef: (EnquiryId) =>
        app.database().ref(`Enquiries/${EnquiryId}/BrokerInvestors`), //adjusted

      //Enquiry singal call list addistion
      removeFromCallListEnquiryRef: (EnquiryId, BrokerCallListId) =>
        app
          .database()
          .ref(`Enquiries/${EnquiryId}/BrokerCallList/${BrokerCallListId}`), //adjusted

      //Remove enquiry from whiteboard
      removeFromWhiteboardEnquiryRef: (EnquiryId, BrokerWhiteboardListId) =>
        app
          .database()
          .ref(
            `Enquiries/${EnquiryId}/BrokerWhiteboard/${BrokerWhiteboardListId}`
          ), //adjusted

      //Remove enquiry from investor
      removeFromInvestorEnquiryRef: (EnquiryId, BrokerInvestorListId) =>
        app
          .database()
          .ref(
            `Enquiries/${EnquiryId}/BrokerInvestors/${BrokerInvestorListId}`
          ), //adjusted

      UnarchiveEnquiryRef: (EnquiryId, archiveId) =>
        app
          .database()
          .ref(`Enquiries/${EnquiryId}/archivedbroker/${archiveId}`), //adjusted

      //ViewedEnquiry
      ViewEnquiryRef: (EnquiryId) =>
        app.database().ref(`Enquiries/${EnquiryId}/viewedBy/`), //adjusted

      //UnreadEnquiry
      UnreadEnquiryRef: (EnquiryId, viewId) =>
        app.database().ref(`Enquiries/${EnquiryId}/viewedBy/${viewId}`), //adjusted

      ////////////////////////////////////////////////////

      //ListingBrochurePDF
      ListingBrochurePdfRef: (ListingId) =>
        app.database().ref(`Listing/${ListingId}/brochure`),

      //Listing
      ListingRef: app.database().ref("Listing"),

      /*=============================================
      =            LandLord Refs                   =
      =============================================*/

      /* list */
      landLordsRef: app.database().ref("landLordsContacts"),

      /* single */
      singleLandLordsRef: (id) => app.database().ref(`landLordsContacts/${id}`),

      /*=====  End of LandLord Refs  ======*/

      ListingOfficeRef: (office) =>
        app.database().ref("Listing").orderByChild("office").equalTo(office),

      //SingleListing
      singleListingRef: (ListingId) =>
        app.database().ref(`Listing/${ListingId}`),
      //Listing Images
      ListingImagesRef: (ListingId, imagenumber) =>
        app.database().ref(`Listing/${ListingId}/images/${imagenumber}`),

        ListingImagesCaptionRef: (ListingId, imagenumber) =>
        app.database().ref(`Listing/${ListingId}/captions/${imagenumber}`),

      allListingImagesRef: (ListingId) =>
        app.database().ref(`Listing/${ListingId}/images`),

      //Listing Video
      ListingVideRef: (ListingId, VideoName) =>
        app.database().ref(`Listing/${ListingId}/videos/${VideoName}`),

      ////////////////////////////////////////////////////
      ////////////////////////////////////////////////////

      //canvassing
      canvasRef: app.database().ref("Canvassing"),

      //SingleCanvas
      singleCanvasRef: (CanvasId) =>
        app.database().ref(`Canvasing/${CanvasId}`),

      userOfficeRef: (office) =>
        app
          .database()
          .ref("users")
          .orderByChild("brokerHomeOffice")
          .equalTo(office),

      userIdRef: (Id) => app.database().ref(`users/${Id}`),

      ////////////////////////////////////////////////////

      bookingListRef: (uid, role) =>
        role === "tenant"
          ? app.database().ref("bookings").orderByChild("tenant").equalTo(uid)
          : role === "broker"
            ? app.database().ref("bookings")
            : role === "landlord"
              ? app.database().ref("bookings")
              : role === "practiceadmin"
                ? app.database().ref("bookings")
                : app.database().ref("bookings"),

      FeesStructureRef: (PracticeNumbers) =>
        app.database().ref(`
      practicetypes/${PracticeNumbers}`),
      DrReferralRef: (referralId) =>
        app.database().ref(`
      DrReferral/${referralId}`),
      DrSpecialityDetailsRef: (bookinguid) =>
        app.database().ref(`
      Booking/${bookinguid}/DrSpecialityDetails`),

      ReferralBrokerRef: app.database().ref(`drsreferrals`),

      ReferralBrokerEditRef: (Brokeruid) =>
        app.database().ref(`drsreferrals/${Brokeruid}`),

      DrSpecialityDetailsRef: (bookinguid) =>
        app.database().ref(`
      Booking/${bookinguid}/DrSpecialityDetails`),

      cancelreasonRef: app.database().ref("cancel_reason"),

      settingsRef: app.database().ref("settings"),

      practiceTypesRef: app.database().ref("practicetypes"),
      practiceTypesEditRef: (id) => app.database().ref("practicetypes/" + id),

      commercialTypesRef: app.database().ref("commercialtypes"),
      commercialTypesEditRef: (id) =>
        app.database().ref("commercialtypes/" + id),
      industrialTypesRef: app.database().ref("industrialtypes"),
      industrialTypesEditRef: (id) =>
        app.database().ref("industrialtypes/" + id),
      userTypesRef: app.database().ref("usertypes"),
      userTypesEditRef: (id) => app.database().ref("usertypes/" + id),
      consultationTypeRef: (id) => app.database.ref(`consultationType`),
      consultationTypeEditRef: (id) =>
        app.database.ref(`consultationType/${id}`),
      ////////////////////////////////////////////////////////////////
      offersRef: (bookingid) =>
        app.database().ref(`bookings/${bookingid}/BookingOffers/`),
      offersEditRef: (bookingid, id) =>
        app.database().ref(`bookings/${bookingid}/BookingOffers/${id}`),
      ////////////////////////////////////////////////////////////////////////////////////////
      medicalHistoryRef: app.database().ref("medicalrecords"),
      medicalHistoryEditRef: (id) => app.database().ref("medicalrecords/" + id),
      ////////////////////////////////////////////////////////////////////////////////////////
      clinicalDiseaseRef: (uid) =>
        app.storage().ref(`users/${uid}/medicalrecords/clinicalDisablities`),
      StoreListingImagesRef: (uid, imagenumber) =>
        app.storage().ref(`Listings/${uid}/Images/${imagenumber}.jpeg`),
      StoreListingBrochureRef: (uid) =>
        app.storage().ref(`Listings/${uid}/Brochure/${uid}`),
      StoreListingVideosRef: (uid, VideoName) =>
        app.storage().ref(`Listings/${uid}/Videos/${VideoName}`),
      ////////////////////////////////////////////////////////////////////////////////////////
      ChatImageRef: (Chatuid) =>
        app.storage().ref(`Images/ChatImage/${Chatuid}`),
      promoRef: app.database().ref("promos"),
      promoEditRef: (id) => app.database().ref("promos/" + id),

      notificationRef: (id) => app.database().ref(`Notifications/${id}`),

      singleNotificationRef: (userid, notificationid) =>
        app.database().ref(`Notifications/${userid}/${notificationid}`),

      notifyRef: app.database().ref("notifications/"),
      notifyEditRef: (id) => app.database().ref("notifications/" + id),
      singleUserRef: (uid) => app.database().ref("users/" + uid),
      singleUserAreasRef: (uid) => app.database().ref(`users/${uid}/Areas`),
      singleUserRegionRef: (uid) => app.database().ref(`users/${uid}/Regions`),
      singleUserSharedBrokersRef: (uid) =>
        app.database().ref("users/" + uid + "/SharedBrokers"),
      UserDeviceInfoRef: (uid) => app.database().ref(`users/${uid}/deviceInfo`),
      PaymentMethodRef: (uid) =>
        app.database().ref("users/" + uid + "/paymentmethod"),
      profileImageRef: (uid) => app.storage().ref(`users/${uid}/profileImage`),
      brokerHomeOfficeRef: (uid) =>
        app.database().ref(`users/${uid}/brokerHomeOffice`),

      groupDocsRef: (timestamp) =>
        app.storage().ref(`users/groupDocuments/${timestamp}/`),
      brokerDocsRef: (timestamp) =>
        app.storage().ref(`users/brokersDocuments/${timestamp}/`),
      tenantDocsRef: (uid, timestamp) =>
        app.storage().ref(`users/${uid}/tenantDocuments/${timestamp}/`),
      landlordDocsRef: (uid, timestamp) =>
        app.storage().ref(`users/${uid}/landlordDocuments/${timestamp}/`),

      ConsentFormRef: (uid) => app.storage().ref(`users/${uid}/ConsentForm`),

      //Region refs
      RegionRef: app.database().ref(`Region/`),
      SingleRegionRef: (regionId) => app.database().ref(`Region/${regionId}`),
      UpdateRegionRef: (regionId) =>
        app.database().ref(`Region/${regionId}/areas`),
      brochureStorageRef: (uid, listingId) =>
        app.storage().ref(`users/${uid}/brochure/${listingId}.pdf`),

      //Area refs
      AreaRef: app.database().ref(`Area/`),
      UpdateAreaRef: (areaId) =>
        app.database().ref(`Area/${areaId}/shareBrokers`),
      UpdateAreaRegionRef: (areaId) =>
        app.database().ref(`Area/${areaId}/Regions`),
      SingleAreaRef: (areaId) => app.database().ref(`Area/${areaId}`),
      SingleAreaRegionsRef: (areaId) =>
        app.database().ref(`Area/${areaId}/Regions`),

      //Chat refs
      EnquiryChatRefs: app.database().ref(`Chats/`),
      SingleEnquiryChatRefs: (EnquiryID) =>
        app.database().ref(`Chats/${EnquiryID}`),

      ChatMessageRefs: (uid) => app.database().ref(`Chats/${uid}/Messages`),

      ChatMembersRefs: (uid) => app.database().ref(`Chats/${uid}/Members`),

      ChatMediaStorageRef: (uid, name) =>
        app.storage().ref(`Chats/${uid}/${name}`),

      userChatRefs: (uid) => app.database().ref(`users/${uid}/UserChats`),
      chatDetailsRef: (uid, chatid) =>
        app.database().ref(`chatDetails/${chatid}/details`),
      conversationRef: (chatid) =>
        app.database().ref(`conversations/${chatid}`),
      groupChatsRef: (uid, chatid) => app.database().ref(`groupChat/${chatid}`),
      groupChatUsersRef: (uid, chatid) =>
        app.database().ref(`groupChatUsers/${chatid}/users`),
      groupChatDetailsRef: (uid, chatid) =>
        app.database().ref(`chatDetails/${chatid}/details`),

      requestedBrokersRef: (bookingKey) =>
        app.database().ref("bookings/" + bookingKey + "/requestedBrokers"),
      walletBalRef: (uid) =>
        app.database().ref("users/" + uid + "/walletBalance"),
      walletHistoryRef: (uid) =>
        app.database().ref("users/" + uid + "/walletHistory"),
      referralIdRef: (referralId) =>
        app
          .database()
          .ref("users")
          .orderByChild("referralId")
          .equalTo(referralId),
      trackingRef: (bookingId) => app.database().ref("tracking/" + bookingId),
      tasksRef: () =>
        app.database().ref("bookings").orderByChild("status").equalTo("NEW"),
      singleTaskRef: (uid, bookingId) =>
        app
          .database()
          .ref("bookings/" + bookingId + "/requestedBrokers/" + uid),

      openfireuserRef: (uid, openfireuser) =>
        app.database().ref(uid + "/openfire/" + openfireuser),
      meetingroomRef: (uid, meetingroom) =>
        app.database().ref(uid + "/openfire/" + meetingroom),
      chatRef: (bookingId) =>
        app.database().ref("chats/" + bookingId + "/messages"),

      brokernotesRef: (bookingId) =>
        app.database().ref("brokernotes/" + bookingId + "/brokersnotes"),

      withdrawRef: app.database().ref("withdraws/"),

      callListEnquiryRef: (EnquiryId) =>
        app.database().ref(`Enquiries/${EnquiryId}/BrokerCallList`), //adjusted

      api: {
        MinutesPassed: MinutesPassed,
        GetDateString: GetDateString,

        fetchCoordsfromPlace: fetchCoordsfromPlace,
        fetchAddressfromCoords: fetchAddressfromCoords,
        getDriveTime: getDriveTime,
        getRouteDetails: getRouteDetails,

        GetDistance: GetDistance,
        GetEventDistance: GetEventDistance,
        saveUserLocation: (uid, location) =>
          app
            .database()
            .ref("users/" + uid + "/location")
            .set(location),
        saveTracking: (bookingId, location) =>
          app
            .database()
            .ref("tracking/" + bookingId)
            .push(location),

        validateReferer: validateReferer,
        checkUserExists: checkUserExists,

        adminEmailSignUp: () => (dispatch) =>
          adminEmailSignUp()(dispatch)(firebase),

        fetchAllUnAssignedAreas: () => (dispatch) =>
          fetchAllUnAssignedAreas()(dispatch)(firebase),

        fetchAllAssignedAreas: () => (dispatch) =>
          fetchAllAssignedAreas()(dispatch)(firebase),

        fetchAllAreas: () => (dispatch) => fetchAllAreas()(dispatch)(firebase),

        addRegion: (regionData) => (dispatch) =>
          addRegion(regionData)(dispatch)(firebase),

        updateRegion: (regionData) => (dispatch) =>
          updateRegion(regionData)(dispatch)(firebase),

        updateRegionAreas: (regionData) => (dispatch) =>
          updateRegionAreas(regionData)(dispatch)(firebase),

        removeAreaFromRegion: (area, regionData) => (dispatch) =>
          removeAreaFromRegion(area, regionData)(dispatch)(firebase),

        PPTokenGenerator: () => (dispatch) => PPTokenGenerator()(dispatch),

        fetchBrokerRegions: () => (dispatch) =>
          fetchBrokerRegions()(dispatch)(firebase),

        addArea: (areaData) => (dispatch) =>
          addArea(areaData)(dispatch)(firebase),

        deleteArea: (areaData) => (dispatch) =>
          deleteArea(areaData)(dispatch)(firebase),

        updateArea: (areaData) => (dispatch) =>
          updateArea(areaData)(dispatch)(firebase),

        updateAreaBroker: (areaData) => (dispatch) =>
          updateAreaBroker(areaData)(dispatch)(firebase),

        removeBrokerFromArea: (broker, areaData) => (dispatch) =>
          removeBrokerFromArea(broker, areaData)(dispatch)(firebase),

        ///////////////////////////////////////////////////////
        // contacts
        fetchContacts: () => (dispatch) => fetchContacts()(dispatch),

        CheckUserSignedIn: () => (dispatch) =>
          CheckUserSignedIn()(dispatch)(firebase),
        addContact: () => (dispatch) => addContact()(dispatch),
        // joomla user
        fetchJmUser: () => (dispatch) => fetchJmUser()(dispatch),
        addJmUser: () => (dispatch) => addJmUser()(dispatch),
        // publication
        publishToWeb: (data) => (dispatch) =>
          publishToWeb(data)(dispatch)(firebase),

        publishToprivateprop: (data, token) => (dispatch) =>
          publishToprivateprop(data, token)(dispatch)(firebase),

        getPrivatePropStatus: (data, token) => (dispatch) =>
          getPrivatePropStatus(data, token)(dispatch)(firebase),

        updatePrivatePropStatus: (data, token) => (dispatch) =>
          updatePrivatePropStatus(data, token)(dispatch)(firebase),

        fetchAgent: (id) => (dispatch) => fetchAgent(id)(dispatch),
        // addAgent: (agentdata, id) => (dispatch) =>
        //   addAgent(agentdata, id)(dispatch)(firebase),

        addAgentP24: (agentdata, id) => (dispatch) =>
          addAgentP24(agentdata, id)(dispatch)(firebase),

        addPpAgent: (agentdata, id, token) => (dispatch) =>
          addPpAgent(agentdata, id, token)(dispatch)(firebase),

        addWebsite: (agentdata, id) => (dispatch) =>
          addWebsite(agentdata, id)(dispatch)(firebase),

        UpdateAgentP24: (agentdata, id) => (dispatch) =>
          UpdateAgentP24(agentdata, id)(dispatch)(firebase),

        publishto24prop: (data, agentId) => (dispatch) =>
          publishto24prop(data, agentId)(dispatch)(firebase),
        // fetch publish articles
        fetchPublication: () => (dispatch) => fetchPublication()(dispatch),
        //casting Enquiry Actions
        // leads
        fetchP24Leads: () => (dispatch) =>
          fetchP24Leads()(dispatch),
        fetchPPLeads: (token, date) => (dispatch) =>
          fetchPPLeads(token, date)(dispatch),
        fetchPPRef: (token, data) => (dispatch) =>
          fetchPPRef(token, data)(dispatch)(firebase),
        fetchPPListingsActivity: (token, data) => (dispatch) =>
          fetchPPListingsActivity(token, data)(dispatch),

        //Create Enquiry

        CreateEnquiry: (EnquiryData, Brokers) => (dispatch) =>
          CreateEnquiry(EnquiryData, Brokers)(dispatch)(firebase),

        ArchiveEnquiry: (EnquiryData, Brokers) => (dispatch) =>
          ArchiveEnquiry(EnquiryData, Brokers)(dispatch)(firebase),

        PullforwardEnquiryForMe: (EnquiryData) => (dispatch) =>
          PullforwardEnquiryForMe(EnquiryData)(dispatch)(firebase),

        PullforwardEnquiryForAll: (EnquiryData) => (dispatch) =>
          PullforwardEnquiryForAll(EnquiryData)(dispatch)(firebase),

        RemovePullforwardEnquiryForMe: (EnquiryData) => (dispatch) =>
          RemovePullforwardEnquiryForMe(EnquiryData)(dispatch)(firebase),

        AddEnquiryToCallList: (EnquiryData, Brokers) => (dispatch) =>
          AddEnquiryToCallList(EnquiryData, Brokers)(dispatch)(firebase),

        AddEnquiryToWhiteboard: (EnquiryData, Brokers) => (dispatch) =>
          AddEnquiryToWhiteboard(EnquiryData, Brokers)(dispatch)(firebase),

        AddEnquiryToInvestor: (EnquiryData, Brokers) => (dispatch) =>
          AddEnquiryToInvestor(EnquiryData, Brokers)(dispatch)(firebase),

        fetchBranchesEnquiries: (branchName) => (dispatch) =>
          fetchBranchesEnquiries(branchName)(dispatch)(firebase),

        fetchCurrentAdminsBranchEnquiries: () => (dispatch) =>
          fetchCurrentAdminsBranchEnquiries()(dispatch)(firebase),

        /*=============================================
        =            Landlord actions            =
        =============================================*/

        /* Create */
        createLandlord: (landlordDetails) => (dispatch) =>
          createLandlord(landlordDetails)(dispatch)(firebase),

        /* fetch List */
        fetchLandlords: (office) => (dispatch) =>
          fetchLandlords(office)(dispatch)(firebase),

        /* Update */
        updateLandlord: (landlordDetails) => (dispatch) =>
          updateLandlord(landlordDetails)(dispatch)(firebase),

        /*=====  End of Landlord actions  ======*/

        //add the action in the same format as ArchiveEnquiry
        ViewedEnquiry: (EnquiryData, Brokers) => (dispatch) =>
          ViewedEnquiry(EnquiryData, Brokers)(dispatch)(firebase),

        //Mark enquiry as unread
        UnreadEnquiry: (EnquiryData) => (dispatch) =>
          UnreadEnquiry(EnquiryData)(dispatch)(firebase),

        //Remove enquiry from call log
        RemoveEnquiryFromCallList: (EnquiryData) => (dispatch) =>
          RemoveEnquiryFromCallList(EnquiryData)(dispatch)(firebase),

        //Remove enquiry from whiteboard
        RemoveEnquiryFromWhiteboard: (EnquiryData) => (dispatch) =>
          RemoveEnquiryFromWhiteboard(EnquiryData)(dispatch)(firebase),

        //Remove enquiry from investor
        RemoveEnquiryFromInvestor: (EnquiryData) => (dispatch) =>
          RemoveEnquiryFromInvestor(EnquiryData)(dispatch)(firebase),

        UnarchiveEnquiry: (EnquiryData, Brokers) => (dispatch) =>
          UnarchiveEnquiry(EnquiryData, Brokers)(dispatch)(firebase),

        //Update Enquiry

        UpdateEnquiry: (UpdatedEnquiryData) => (dispatch) =>
          UpdateEnquiry(UpdatedEnquiryData)(dispatch)(firebase),

        //remove pull forward for all
        RemovePullforwardForAll: (UpdatedEnquiryData) => (dispatch) =>
          RemovePullforwardForAll(UpdatedEnquiryData)(dispatch)(firebase),

        //Create branch

        createBranch: (officeData) => (dispatch) =>
          createBranch(officeData)(dispatch)(firebase),

        //update branch

        updateBranch: (officeData) => (dispatch) =>
          updateBranch(officeData)(dispatch)(firebase),

        //remove branch

        deleteBranch: (officeData) => (dispatch) =>
          deleteBranch(officeData)(dispatch)(firebase),

        //Generate Listing Brochure PDF
        generatePDF: (enquiry, data) => (dispatch) =>
          generatePDF(enquiry, data, enquiry)(dispatch)(firebase),

        //Get pdf links
        generatePdfLinks: (webRefs, multi) => (dispatch) =>
          generatePdfLinks(webRefs, multi)(dispatch)(firebase),

        //upload listing brochure
        uploadListingWithBrochure:
          (updatedListingData, pdfBlob) => (dispatch) =>
            uploadListingWithBrochure(updatedListingData, pdfBlob)(dispatch)(
              firebase
            ),

        //get branch

        fetchAllBranches: () => (dispatch) =>
          fetchAllBranches()(dispatch)(firebase),

        //get regions
        fetchAllRegions: () => (dispatch) =>
          fetchAllRegions()(dispatch)(firebase),

        //clear login error
        clearLoginError: () => (dispatch) =>
          clearLoginError()(dispatch)(firebase),

        //get branch by name

        get_Branch_By_Name: () => (dispatch) =>
          get_Branch_By_Name()(dispatch)(firebase),

        //Delete Enquiry
        DeleteEnquiry: (deleteEnquiryData) => (dispatch) =>
          DeleteEnquiry(deleteEnquiryData)(dispatch)(firebase),

        //fetch Users Equiry history
        //if you want to get the current logged in users history uid is not required
        //if you want to get the history of a specific user uid is required
        fetchUsersEnquriesFromOtherLocations: (uid) => (dispatch) =>
          fetchUsersEnquriesFromOtherLocations(uid)(dispatch)(firebase),

        SendPushNotification:
          (notification) =>
            (
              dispatch //to send push notifications
            ) =>
              SendPushNotification(notification)(dispatch)(firebase),

        SendBulkPushNotification: (notification) => (dispatch) =>
          SendBulkPushNotification(notification)(dispatch)(firebase),

        SendEnquiryGroupChatNotification:
          (notificationInfomation, brokerIgnoreList) => (dispatch) =>
            SendEnquiryGroupChatNotification(
              notificationInfomation,
              brokerIgnoreList
            )(dispatch)(firebase),

        fetchEnquriesFromOtherLocations: (uid) => (dispatch) =>
          fetchEnquriesFromOtherLocations(uid)(dispatch)(firebase),

        fetchUserEnquiryhistory: (uid, office) => (dispatch) =>
          fetchUserEnquiryhistory(uid, office)(dispatch)(firebase),

        fetchSingleEnquiry: (data) => (dispatch) =>
          fetchSingleEnquiry(data)(dispatch)(firebase),

        addtoEnquiryTimeline: (enquiryData, eventData) => (dispatch) =>
          addtoEnquiryTimeline(enquiryData, eventData)(dispatch)(firebase),

        fetchformEnquiryTimeline: (id) => (dispatch) =>
          fetchformEnquiryTimeline(id)(dispatch)(firebase),

        //Error Managment for Enquiry
        clearEnquiryErrors: () => (dispatch) =>
          clearEnquiryErrors()(dispatch)(firebase),
        clearPublishErrors: () => (dispatch) => clearPublishErrors()(dispatch),

        //Success management for pull forwarding an enquiry
        clearPullforwardEnquirySuccess: () => (dispatch) =>
          clearPullforwardEnquirySuccess()(dispatch)(firebase),

        ////////////////////////////////////////////////////////////////////////////////////

        //casting Listing actions
        //Duplicate Listing
        duplicateListing: (listingData) => (dispatch) =>
          duplicateListing(listingData)(dispatch)(firebase),
        //Create Listing
        CreateListing: (ListingData, picture, video) => (dispatch) =>
          CreateListing(ListingData, picture, video)(dispatch)(firebase),

        //Update Listing
        UpdateListing: (UpdatedListingData, pictures) => (dispatch) =>
          UpdateListing(UpdatedListingData, pictures)(dispatch)(firebase),

        UpdateListingPrimary: (UpdatedListingData, pictures) => (dispatch) =>
          UpdateListingPrimary(UpdatedListingData, pictures)(dispatch)(firebase),

        //Delete Listing PDF
        DeleteListingPdf: (ListingId) => (dispatch) =>
          DeleteListingPdf(ListingId)(dispatch)(firebase),

        //Delete Listing
        DeleteListing: (deleteListingData) => (dispatch) =>
          DeleteListing(deleteListingData)(dispatch)(firebase),

        //fetch User Listing history
        //if you want to get the current logged in users history uid is not required
        //if you want to get the history of a specific user uid is required
        fetchUserListinghistory: (uid) => (dispatch) =>
          fetchUserListinghistory(uid)(dispatch)(firebase),

        RemovePullforwardListingsForAll: (listingData) => (dispatch) =>
          RemovePullforwardListingsForAll(listingData)(dispatch)(firebase),

        fetchAllListings: () => (dispatch) =>
          fetchAllListings()(dispatch)(firebase),

        fetchAllBranchListings: (branch) => (dispatch) =>
          fetchAllBranchListings(branch)(dispatch)(firebase),

        fetchCurrentAdminsBranchListings: () => (dispatch) =>
          fetchCurrentAdminsBranchListings()(dispatch)(firebase),

        fetchWebsiteAreas: () => (dispatch) => fetchWebsiteAreas()(dispatch),

        // Sync actions
        syncTop24: (listingData) => (dispatch) =>
          syncTop24(listingData)(dispatch)(firebase),

        syncToPP: (listingData) => (dispatch) =>
          syncToPP(listingData)(dispatch)(firebase),

        syncToWebsite: (listingData) => (dispatch) =>
          syncToWebsite(listingData)(dispatch)(firebase),

        //Error Managment for Listing
        getFileUrl: () => (firebase) =>
          getFileUrl()(firebase),

        //get API logo
        clearListingErrors: () => (dispatch) =>
          clearListingErrors()(dispatch)(firebase),
        clearListingErrorsPrimary: () => (dispatch) =>
          clearListingErrorsPrimary()(dispatch)(firebase),

        //clear user error
        clearUserErrors: () => (dispatch) =>
          clearUserErrors()(dispatch)(firebase),
        ////////////////////////////////////////////////////////////////////////////////////

        //Error Managment for Listing
        clearBranchErrors: () => (dispatch) =>
          clearBranchErrors()(dispatch)(firebase),

        //Error Managment for Listing
        registerForPushNotificationsAsync:
          (Constants, Notifications, isDevice) => (dispatch) =>
            registerForPushNotificationsAsync(
              Constants,
              Notifications,
              isDevice
            )(dispatch)(firebase),
        ////////////////////////////////////////////////////////////////////////////////////

        //Create Canvas
        CreateCanvas: (CanvasData) => (dispatch) =>
          CreateCanvas(CanvasData)(dispatch)(firebase),

        //Update Canvas
        UpdateCanvas: (UpdatedCanvasData) => (dispatch) =>
          UpdateCanvas(UpdatedCanvasData)(dispatch)(firebase),
        fetchCanvas: () => (dispatch) => fetchCanvas()(dispatch)(firebase),
        //Delete Canvas
        DeleteCanvas: (deleteCanvasData) => (dispatch) =>
          DeleteCanvas(deleteCanvasData)(dispatch)(firebase),
        //////
        //Casting Matching actions
        MatchListingToEnquiry: (EnquiryData) => (dispatch) =>
          MatchListingToEnquiry(EnquiryData)(dispatch)(firebase),

        MatchEnquiryToListings: (ListingData) => (dispatch) =>
          MatchEnquiryToListings(ListingData)(dispatch)(firebase),

        //Casting Chats action
        CreateChat: (ChatData) => (dispatch) =>
          CreateChat(ChatData)(dispatch)(firebase),

        FetchChats: (ChatData) => (dispatch) =>
          FetchChats(ChatData)(dispatch)(firebase),

        SendChatMesssage: (MessageData, enquiryData) => (dispatch) =>
          SendChatMesssage(MessageData, enquiryData)(dispatch)(firebase),

        fetchUser: () => (dispatch) => fetchUser()(dispatch)(firebase),
        emailSignUp: (data) => emailSignUp(data)(firebase),
        mobileSignIn: (verficationId, code) => (dispatch) =>
          mobileSignIn(verficationId, code)(dispatch)(firebase),
        AddPaymentMethod: (PaymentMethodDetails) => (dispatch) =>
          AddPaymentMethod(PaymentMethodDetails)(dispatch)(firebase),
        signIn: (email, password) => (dispatch) =>
          signIn(email, password)(dispatch)(firebase),
        facebookSignIn: (token) => (dispatch) =>
          facebookSignIn(token)(dispatch)(firebase),
        appleSignIn: (credentialData) => (dispatch) =>
          appleSignIn(credentialData)(dispatch)(firebase),
        signOut: () => (dispatch) => signOut()(dispatch)(firebase),
        updateProfile: (userAuthData, updateData) => (dispatch) =>
          updateProfile(userAuthData, updateData)(dispatch)(firebase),
        monitorProfileChanges: () => (dispatch) =>
          monitorProfileChanges()(dispatch)(firebase),

        // these are viewing bookings for client to view properties
        fetchBookings: (uid, role) => (dispatch) =>
          fetchBookings(uid, role)(dispatch)(firebase),
        updateBooking: (booking) => (dispatch) =>
          updateBooking(booking)(dispatch)(firebase),
        cancelBooking: (data) => (dispatch) =>
          cancelBooking(data)(dispatch)(firebase),
        // Property offers
        addOffers: (bookingoffersdata, method) => (dispatch) =>
          addOffers(bookingoffersdata, method)(dispatch)(firebase),
        updateOffers: (bookingoffersdata, method) => (dispatch) =>
          updateOffers(bookingoffersdata, method)(dispatch)(firebase),
        fetchOffers: () => (dispatch) => fetchOffers()(dispatch)(firebase),
        //
        fetchCancelReasons: () => (dispatch) =>
          fetchCancelReasons()(dispatch)(firebase),
        editCancellationReason: (reasons, method) => (dispatch) =>
          editCancellationReason(reasons, method)(dispatch)(firebase),

        // editMedicalHistory: (data, method, blob, metadata) => (dispatch) =>
        //   editMedicalHistory(data, method, blob, metadata)(dispatch)(firebase),
        // fetchMedicalHistory: () => (dispatch) =>
        //   fetchMedicalHistory()(dispatch)(firebase),

        // fetchReferralDrType: () => (dispatch) =>
        //   fetchReferralDrType()(dispatch)(firebase),
        // editReferralDrType: (data, method) => (dispatch) =>
        //   editReferralDrType(data, method)(dispatch)(firebase),

        fetchCommercialTypes: () => (dispatch) =>
          fetchCommercialTypes()(dispatch)(firebase),
        editCommercialType: (data, method) => (dispatch) =>
          editCommercialType(data, method)(dispatch)(firebase),
        fetchIndustrialTypes: () => (dispatch) =>
          fetchIndustrialTypes()(dispatch)(firebase),
        editIndustrialType: (data, method) => (dispatch) =>
          editIndustrialType(data, method)(dispatch)(firebase),
        fetchUserTypes: () => (dispatch) =>
          fetchUserTypes()(dispatch)(firebase),
        editUserType: (data, method) => (dispatch) =>
          editUserType(data, method)(dispatch)(firebase),

        SaveUsersDeviceInfo:
          (NewPushtoken, previousdeviceinfo, currentdeviceinfo) => (dispatch) =>
            SaveUsersDeviceInfo(
              NewPushtoken,
              previousdeviceinfo,
              currentdeviceinfo
            )(dispatch)(firebase),
        // CreateMeetingLink: (roomName, naturalName, description) => (dispatch) =>
        //   CreateMeetingLink(roomName, naturalName, description)(dispatch)(
        //     firebase
        //   ),
        // DeleteMeetingLink: (roomName, naturalName, uid) => (dispatch) =>
        //   DeleteMeetingLink(roomName, naturalName, uid)(dispatch)(firebase),
        getEstimate: (bookingData) => (dispatch) =>
          getEstimate(bookingData)(dispatch)(firebase),
        clearEstimate: () => (dispatch) => clearEstimate()(dispatch)(firebase),
        fetchSettings: () => (dispatch) => fetchSettings()(dispatch)(firebase),
        editSettings: (settings) => (dispatch) =>
          editSettings(settings)(dispatch)(firebase),
        clearSettingsViewError: () => (dispatch) =>
          clearSettingsViewError()(dispatch)(firebase),
        sendResetMail: (email) => (dispatch) =>
          sendResetMail(email)(dispatch)(firebase),
        fetchBrokerEarnings: (uid, role) => (dispatch) =>
          fetchBrokerEarnings(uid, role)(dispatch)(firebase),
        fetchEarningsReport: () => (dispatch) =>
          fetchEarningsReport()(dispatch)(firebase),
        fetchNotifications: () => (dispatch) =>
          fetchNotifications()(dispatch)(firebase),
        editNotifications: (notifications, method) => (dispatch) =>
          editNotifications(notifications, method)(dispatch)(firebase),
        sendNotification: (notification) => (dispatch) =>
          sendNotification(notification)(dispatch)(firebase),

        fetchUserNotification: (id) => (dispatch) =>
          fetchUserNotification(id)(dispatch)(firebase),

        deleteNotification: (userid, notificationid) => (dispatch) =>
          deleteNotification(userid, notificationid)(dispatch)(firebase),

        UpdateNotification: (userid, notificationid, updates) => (dispatch) =>
          UpdateNotification(userid, notificationid, updates)(dispatch)(
            firebase
          ),

        fetchPromos: () => (dispatch) => fetchPromos()(dispatch)(firebase),
        editPromo: (data, method) => (dispatch) =>
          editPromo(data, method)(dispatch)(firebase),

        fetchUsers: () => (dispatch) => fetchUsers()(dispatch)(firebase),
        fetchAdmins: () => (dispatch) => fetchAdmins()(dispatch)(firebase),

        fetchLoggedInUser: (user) => (dispatch) =>
          fetchLoggedInUser(user)(dispatch)(firebase),
        fetchBrokers: () => (dispatch) => fetchBrokers()(dispatch)(firebase),
        updateUserConsentform: (userid, file) => (dispatch) =>
          updateUserConsentform(userid, file)(dispatch)(firebase),
        addUser: (userdata) => (dispatch) =>
          addUser(userdata)(dispatch)(firebase),
        editUser: (id, user) => (dispatch) =>
          editUser(id, user)(dispatch)(firebase),
        editUserSharedBrokers: (id, user) => (dispatch) =>
          editUserSharedBrokers(id, user)(dispatch)(firebase),
        editBrokerApproval: (userData) => (dispatch) =>
          editBrokerApproval(userData)(dispatch)(firebase),

        EditBroker: (data, userid) => (dispatch) =>
          EditBroker(data, userid)(dispatch)(firebase),

        AddBroker: (data) => (dispatch) => AddBroker(data)(dispatch)(firebase),

        AddP24: (data, userid) => (dispatch) =>
          AddP24(data, userid)(dispatch)(firebase),

        AddWebsite: (data, userid) => (dispatch) =>
          AddWebsite(data, userid)(dispatch)(firebase),

        updatePushToken: (userAuthData, token, platform) => (dispatch) =>
          updatePushToken(userAuthData, token, platform)(dispatch)(firebase),
        updateProfileImage: (userAuthData, imageBlob) => (dispatch) =>
          updateProfileImage(userAuthData, imageBlob)(dispatch)(firebase),
        addBrokerHomeOffice: (userId, brokerHomeOffice) => () =>
          addBrokerHomeOffice(userId, brokerHomeOffice)()(firebase),
        updateWebProfileImage: (userAuthData, imageFile) => (dispatch) =>
          updateWebProfileImage(userAuthData, imageFile)(dispatch)(firebase),
        requestPhoneOtpDevice: (phoneNumber, appVerifier) => (dispatch) =>
          requestPhoneOtpDevice(phoneNumber, appVerifier)(dispatch)(firebase),
        deleteUser: (uid) => (dispatch) => deleteUser(uid)(dispatch)(firebase),
        fetchPaymentMethods: () => (dispatch) =>
          fetchPaymentMethods()(dispatch)(firebase),
        addToWallet: (uid, amount) => (dispatch) =>
          addToWallet(uid, amount)(dispatch)(firebase),

        clearAiReducer: () => (dispatch) =>
          clearAiReducer()(dispatch)(firebase),

        GenerateListingDescription: (data) => (dispatch) =>
          GenerateListingDescription(data)(dispatch)(firebase),

        GenerateListingKeywords: (data) => (dispatch) =>
          GenerateListingKeywords(data)(dispatch)(firebase),

        updateWalletBalance: (balance, details) => (dispatch) =>
          updateWalletBalance(balance, details)(dispatch)(firebase),
        clearMessage: () => (dispatch) => clearMessage()(dispatch)(firebase),
        updateEventPickup: (pickupAddress) => (dispatch) =>
          updateEventPickup(pickupAddress)(dispatch)(firebase),
        updateEventDrop: (dropAddress) => (dispatch) =>
          updateEventDrop(dropAddress)(dispatch)(firebase),
        updateEventPractice: (selectedPractice) => (dispatch) =>
          updateEventPractice(selectedPractice)(dispatch)(firebase),
        updatSelPointType: (selection) => (dispatch) =>
          updatSelPointType(selection)(dispatch)(firebase),
        clearEventPoints: () => (dispatch) =>
          clearEventPoints()(dispatch)(firebase),
        fetchTasks: () => (dispatch) => fetchTasks()(dispatch)(firebase),
        acceptTask: (userAuthData, task) => (dispatch) =>
          acceptTask(userAuthData, task)(dispatch)(firebase),
        cancelTask: (bookingId) => (dispatch) =>
          cancelTask(bookingId)(dispatch)(firebase),
        fetchBookingLocations: (bookingId) => (dispatch) =>
          fetchBookingLocations(bookingId)(dispatch)(firebase),
        stopLocationFetch: (bookingId) => (dispatch) =>
          stopLocationFetch(bookingId)(dispatch)(firebase),

        fetchChatMessages: (id) => (dispatch) =>
          fetchChatMessages(id)(dispatch)(firebase),

        leaveChat: (ChatInfo) => (dispatch) =>
          leaveChat(ChatInfo)(dispatch)(firebase),

        sendMessage: (data) => (dispatch) =>
          sendMessage(data)(dispatch)(firebase),
        stopFetchMessages: (bookingId) => (dispatch) =>
          stopFetchMessages(bookingId)(dispatch)(firebase),

        fetchBrokerNotes: (bookingId) => (dispatch) =>
          fetchBrokerNotes(bookingId)(dispatch)(firebase),
        addBrokersNotes: (data) => (dispatch) =>
          addBrokersNotes(data)(dispatch)(firebase),
        stopFetchBrokerNotes: (bookingId) => (dispatch) =>
          stopFetchBrokerNotes(bookingId)(dispatch)(firebase),

        createMeetingRoom: (firstName, lastName) => (dispatch) =>
          createMeetingRoom(firstName, lastName)(dispatch)(firebase),

        createOpenfireUser:
          (username, password, firstName, lastName, email) => (dispatch) =>
            createOpenfireUser(
              username,
              password,
              firstName,
              lastName,
              email
            )(dispatch)(firebase),

        deleteMeetingRoom: (firstName) => (dispatch) =>
          deleteMeetingRoom(firstName)(dispatch)(firebase),

        fetchWithdraws: () => (dispatch) =>
          fetchWithdraws()(dispatch)(firebase),
        completeWithdraw: (entry) => (dispatch) =>
          completeWithdraw(entry)(dispatch)(firebase),

        fetchBroker: (id) => (dispatch) => fetchBroker(id)(dispatch)(firebase),
        fetchCities: (provinceId) => (dispatch) =>
          fetchCities(provinceId)(dispatch),
        fetchSuburbs: (cityId) => (dispatch) => fetchSuburbs(cityId)(dispatch),
        fetchWebsiteAreas: () => (dispatch) => fetchWebsiteAreas()(dispatch),
        fetchPPCities: (ProvinceID, token) => (dispatch) => fetchPPCities(ProvinceID, token)(dispatch),
        fetchPPSuburbs: (ProvinceID, token) => (dispatch) => fetchPPSuburbs(ProvinceID, token)(dispatch)
      }
    };
  }

  return (
    <FirebaseContext.Provider value={firebase}>
      {children}
    </FirebaseContext.Provider>
  );
};

export { FirebaseContext, FirebaseProvider, store };
